/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashboard_Recentsales_Description1Inputs */

const he_dashboard_recentsales_description1 = /** @type {(inputs: Dashboard_Recentsales_Description1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ביצעתם ${i?.count} מכירות החודש.`)
};

const en_dashboard_recentsales_description1 = /** @type {(inputs: Dashboard_Recentsales_Description1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You made ${i?.count} sales this month.`)
};

/**
* | output |
* | --- |
* | "You made {count} sales this month." |
*
* @param {Dashboard_Recentsales_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentsales_description1 = /** @type {((inputs: Dashboard_Recentsales_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentsales_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentsales_description1(inputs)
	return en_dashboard_recentsales_description1(inputs)
});
export { dashboard_recentsales_description1 as "dashboard_recentSales_description" }